<template>
  <div class="floor-partner floor">
    <div class="container">
      <h2 class="floor__h2">合作伙伴</h2>
      <hr class="floor__line">
      <p class="floor__desc">与腾讯、华为等多家企业深度合作，值得信赖</p>
      <ul class="clearfix">
        <li v-for="(item, index) in list" :key="index">
          <img v-lazy="item.colorIcon">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const list = [];
for (let i = 0; i < 12; i++) {
  list.push({
    grayIcon: `//s1.huishoubao.com/static/pc/1001/img/6_${i + 1}.png`,
    colorIcon: `//s1.huishoubao.com/static/pc/1001/img/6_${i + 1}_1.png`
  });
}
export default {
  data () {
    return {
      list
    };
  }
};
</script>

<style lang="postcss" scoped>
 @keyframes animate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
.floor-partner {
  background: #fff;
  padding-bottom: 30px;
  margin-top: 40px;
}
ul {
  margin-top: 30px;
  box-shadow: 0 0 10px rgba(0,0,0,.12);
}
li {
  float: left;
  width: 25%;
  border-right: solid 1px #f2f2f2;
  border-bottom: solid 1px #f2f2f2;
  cursor: pointer;
  &:hover img {
    transform: scale(1.2);
  }
}
img {
  position: relative;
  left: 42px;
  height: 120px;
  transition: all .3s linear;
}
.no-bottom-border {
  border-bottom: 0;
}
.no-right-border {
  border-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-partner.vue